;(function () {
  'use strict'

  angular.module('contrast.survey').constant('SURVEY_STATES', {
    PENDING: 'PENDING',
    DECLINED: 'DECLINED',
    COMPLETED: 'COMPLETED'
  })
})()
